import { apiDaInscricao } from "../../../servicos/axios";

export type FinalizarAtendimentoPayload = {
  agendamentoId: number;
  servicoIds: number[];
};

export type ApiAgendamento = {
  id: number;
  dataInicial: string;
  dataFinal?: string;
  status: string;
};

export const finalizarAtendimento = async (
  payload: FinalizarAtendimentoPayload
): Promise<ApiAgendamento> => {
  const api = apiDaInscricao();
  const resp = await api.post("/agendamento/Finalizar", payload);
  return resp.data?.agendamento as ApiAgendamento;
};
